<template>
<div>清除缓存</div>
</template>
<script>
import { clear } from '../../utils/token'
import Cookies from 'js-cookie'
export default {
  beforeRouteEnter (to, from, next) {
    next(vm => {
      clear()
      const str = Cookies.get()
      alert(JSON.stringify(str))
    })
  }
}
</script>
<style scoped>

</style>
